import { useEffect, useState } from 'react';

/**
 * Delay propagating a fast-changing value (a search box) to whatever refetches.
 *
 * Several product grids used to fire a request per keystroke, which put a
 * request per character on the wire and let a slow early response land after a
 * fast later one. Hold the draft in local state, feed it through here, and key
 * the fetch off the returned value.
 */
export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
